import { render, staticRenderFns } from "./servicioTecnico.vue?vue&type=template&id=381991b6&"
import script from "./servicioTecnico.vue?vue&type=script&lang=js&"
export * from "./servicioTecnico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports